import React from 'react'

export default class NotFound extends React.Component {
  state={}
  componentDidMount() {

  }
  render() {
    const {t} = this.props
    return (
      <div>
        <h1>{t('notFound:Page not found')}</h1>
        <div className="main-content">
          <p>404 - {t('notFound:Page not found')}</p>
        </div>
      </div>
    )
  }
}
